<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <h2 class="ui primary header">Manage Applications</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <!-- <button (click)="deleteTemplate()" class="ui small basic primary  icon button" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="remove organizationType data">
                <i class="trash alternate icon"></i>
                </button> -->

      <button
        *isPermitted="{ id: 'APPLICATIONS_MANAGEMENT', action: 'add' }"
        (click)="addApplication()"
        class="ui small button primary"
      >
        Create New Application
      </button>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>
  <div *ngIf="success || error">
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>

  <!-- <div class="ui segment" style="border-radius: 4px;" appMargin marginT="0"> -->
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <!-- </div> -->

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <!-- <div fxFlex="3%">
		   <sui-checkbox >
            </sui-checkbox>
	</div> -->
      <div fxFlex="10%">NAME</div>
      <div fxFlex="15%">HOST</div>
      <div fxFlex="15%">PUBLIC ACCESS</div>
      <!-- <div  fxFlex="15%">DESCRIPTION</div> -->
      <div fxFlex="10%">HIDDEN FROM DASHBOARD</div>
      <div fxFlex="10%">DATE ADDED</div>
      <div fxFlex="10%">ADDED BY</div>
      <div fxFlex="18%"></div>
    </div>

    <app-application-row
      [application]="s"
      *ngFor="let s of applications"
      (onHide)="onHide($event)"
      (onShow)="onShow($event)"
      (onChangeImage)="popUploadModal($event)"
      (onView)="onView($event)"
      (onDelete)="onDelete($event)"
      (onEdit)="onEdit($event)"
    ></app-application-row>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template let-context let-modal="modal" #uploadModalTemplate>
  <div class="header">Change Application Logo</div>
  <div class="content">
    <div fxLayout="row" fxLayoutGap="10px">
      <div fxFlex="50%">
        <img-cropper
          #cropper
          [image]="data"
          [settings]="cropperSettings"
        ></img-cropper>
        <div class="file-upload">
          <input
            id="custom-input"
            #uploadDoc
            type="file"
            accept=".pdf,.doc,.docx,.odf:not(.zip),.xls,.xlsx"
            #uploader
            (change)="fileChangeListener($event)"
            placeholder="Browse for documents"
            onclick="value = null"
          />
        </div>
      </div>
      <div fxFlex="50%" class="text-right">
        <div>
          <img
            [src]="data?.image"
            [width]="cropperSettings.croppedWidth"
            [height]="cropperSettings.croppedHeight"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="actions">
    <button class="ui button" (click)="modal.deny('approved')" autofocus>
      Cancel
    </button>
    <button
      class="ui primary button"
      (click)="modal.approve('approved')"
      autofocus
    >
      Upload logo
    </button>
  </div>
</ng-template>
